export const INTERNAL_SERVER_ERROR_MSG =
  "Request error. There may be a connection problem or the server is unavailable. Wait and try again.";
export const DEFAULT_ERROR_MSG = "Something went wrong...";
export const NOT_FOUND_ERROR_MSG = "Nothing found";
export const FORBIDDEN_ERROR_MSG =
  "You don't have permission to perform this action";
export const BAD_REQUEST_ERROR_MSG =
  "The entered data was not validated on the server";

// user and authorization
export const SUCCESSFUL_SIGNUP_MSG = "You have successfully signed up";
export const SIGNUP_ERROR_MSG =
  "Failed to sign up. There may be a connection problem or the server is unavailable. Please wait and try again.";
export const AUTHORIZATION_FAILED_ERROR_MSG = "Authorisation Error";
export const UNAUTHORIZED_ERROR_MSG = "Authorization required";
export const SIGNOUT_ERROR_MSG =
  "Failed to sign out. There may be a connection problem or the server is unavailable. Please wait and try again.";
export const SUCCESSFUL_SIGNOUT_MSG = "You have successfully signed out";

// reset password
export const RESET_PASSWORD_EMAIL_SENT_MSG =
  "E-mail has been sent, please follow the instructions.";

// email
export const UPDATE_EMAIL_EMAIL_SENT_MSG =
  "Confirmation links have been sent to your current and new email addresses. Confirm both within 20 minutes to complete the change.";
export const EMAIL_UPDATE_REQUEST_ERROR_MSG =
  "Error! E-mail change request failed";
export const EMAIL_UPDATED_SUCCESSFULLY_MSG =
  "Your email has been updated. Sign in with your new email address.";
export const EMAIL_UPDATE_ERROR_MSG = "Error! E-mail has not been updated";
export const PASSWORD_UPDATED_SUCCESSFULLY_MSG =
  "E-mail has been successfully updated";
export const PASSWORD_UPDATE_ERROR_MSG = "Error! E-mail has not been updated";

// photos
export const SUCCESSFUL_PHOTO_DELETE_MSG = "Photo was deleted.";
export const DELETE_PHOTO_ERROR_MSG =
  "Failed to delete photo. Please wait and try again later.";
export const PHOTO_ADDED_SUCCESSFULLY_MSG = "Photo was added successfully";
export const PHOTOS_ADDED_SUCCESSFULLY_MSG = (count) =>
  `${count} photos were added successfully`;
export const PHOTOS_UPLOAD_SUCCESS_MSG = (count) =>
  `Successfully uploaded photos: ${count}`;
export const PHOTOS_UPLOAD_FAILED_MSG = (failedCount) =>
  `No photos were uploaded.\nFailed photos: ${failedCount}`;
export const EDIT_HASHTAGS_ERROR_MSG =
  "Failed to edit hashtags. Please wait and try again later.";

// projects
export const PROJECT_ADDED_SUCCESSFULLY_MSG = "Project was successfully added";
export const PROJECT_ADD_ERROR_MSG = "Project cannot be added";
export const PROJECT_EDITED_SUCCESSFULLY_MSG =
  "Project was successfully edited";
export const PROJECT_EDIT_ERROR_MSG = "Editing error, please try again later";

// posts
export const POST_ADDED_SUCCESSFULLY_MSG = "Post was successfully added";
export const POST_ADD_ERROR_MSG = "Post cannot be added";
export const POST_EDITED_SUCCESSFULLY_MSG = "Post was successfully edited";
export const POST_EDIT_ERROR_MSG = "Editing error, please try again later";

// contact form
export const CONTACT_MESSAGE_SENT_MSG = "Your message has been sent.";
export const CONTACT_MESSAGE_ERROR_MSG =
  "Failed to send the message. Please try again later.";
